import routes from 'routes'
import { useRoutes } from 'react-router'
import { I18nextProvider } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { sagaActions } from '@/redux/sagaActions'
import { useEffect } from 'react'
import i18n from './i18n'
import { RootState } from '@/redux/reducers'
import { useNavigate, useLocation } from 'react-router'
import { ThemeProvider } from '@/ui-components/context/ThemeProvider'
import { clearNavigatePath } from './redux/reducers/routerReducer'
import { wrapUseRoutesV7 } from '@sentry/react'

function App() {
  // Ref: https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/#usage-with-useroutes-hook
  const useSentryRoutes = wrapUseRoutesV7(useRoutes)
  const content = useSentryRoutes(routes)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  if (import.meta.env.VITE_ENV !== 'local') {
    // console.log = function () {
    //   return
    // }
    // console.error = function () {
    //   return
    // }
    // console.warn = function () {
    //   return
    // }
  }

  const targetPath = useSelector((state: RootState) => {
    return state.router?.navigatePath
  })

  const targetDelay = useSelector((state: RootState) => {
    return state.router?.delay ? state.router.delay : 0
  })

  const globalError = useSelector((state: RootState) => state.error.globalError)
  const title = useSelector((state: RootState) => state.user?.title)
  const faviconUrl = useSelector((state: RootState) => state.user?.faviconUrl)

  useEffect(() => {
    document.title = title ? title : 'RB7 Lotto'
  }, [title])

  useEffect(() => {
    const linkElement = document.querySelector("link[rel='icon']")
    if (linkElement)
      linkElement.setAttribute('href', faviconUrl ? faviconUrl : '/favicon.ico')
  }, [faviconUrl])

  useEffect(() => {
    if (globalError?.code === 404) {
      navigate('/404')
    }
    if (globalError?.code === 401) {
      navigate('/session_error')
    }
  }, [globalError, navigate])

  useEffect(() => {
    if (location.pathname === '/session_error') {
      return
    }
    dispatch({
      type: sagaActions.INITIALIZE_APP,
      payload: {
        location: location,
      },
    })
  }, [dispatch, location])

  useEffect(() => {
    console.log('Component didmount: APP TSX')
    const timeOut = targetDelay

    if (targetPath) {
      setTimeout(() => {
        navigate(targetPath)
        // Clear the navigation path after it's been used to prevent unwanted redirects
        dispatch({ type: clearNavigatePath.type })
      }, timeOut)
    }
  }, [targetPath, navigate, targetDelay, dispatch])

  return (
    <ThemeProvider>
      <I18nextProvider i18n={i18n}>{content}</I18nextProvider>
    </ThemeProvider>
  )
}

export default App
